<script lang="ts">
import { onMount } from "svelte";
import axios from "axios";
import TemplateCard from "./TemplateCard.svelte";
import { addEvents } from "./utils/logger";
import { v4 } from "uuid";
import { fade } from "svelte/transition";
import Spinner from "./components/Spinner.svelte";

let templates: Template[] = [];
let searched = false;
let query = "dashboard";
let loading = false;

const requestTemplates = async (query: string) => {
  if (loading) {
    return;
  }

  loading = true;

  try {
    const {
      data: { data },
    } = await axios.get<{ createdAt: string; data: Template[] }>(
      `https://oopy.lazyrockets.com/api/nft/search?query=${query}`
    );

    templates = [...data];
  } finally {
    loading = false;
  }
};

const onSearch = async (value: string) => {
  query = value;
  await requestTemplates(value);
  addEvents([
    {
      level: "info",
      message: "query",
      fields: {
        query: value,
        userId: localStorage.getItem("userId"),
      },
    },
  ]);
  window.scrollTo({ top: 0 });
  searched = true;
};

const onSubmit = async (e: Event) => {
  e.preventDefault();

  onSearch(e.target[0].value);
};

onMount(() => {
  requestTemplates(query);

  const userId = localStorage.getItem("userId") || v4();

  localStorage.setItem("userId", userId);
});
</script>

<body>
  <form class="container" on:submit={onSubmit}>
    <div class="search-container">
      <input class="search" bind:value={query} />
      <button type="submit" class="search-submit">
        <img
          src="https://cdn2.iconfinder.com/data/icons/font-awesome/1792/search-512.png" />
      </button>
    </div>
    {#if templates.length > 0}
      <div class="template-container">
        {#each templates as template}
          <TemplateCard {template} onTagClick={onSearch} />
        {/each}
      </div>
    {:else if searched}
      No search result
    {:else}
      Search something!
    {/if}
  </form>
  {#if loading}
    <div class="layer" transition:fade>
      <Spinner />
    </div>
  {/if}
</body>

<style type="text/scss">
.container {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 900px;
  margin: 0 auto;

  .search-container {
    position: sticky;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    top: 0px;
    left: 0;
    right: 0;
    background-color: white;
    z-index: 100;

    .search {
      width: 100%;
      height: 48px;
      padding: 0 64px 0 16px;
      border-radius: 32px;
      border: 2px solid black;
      background-color: transparent;
      outline: none;
      color: rgb(55, 53, 47);
      font-weight: bold;
    }

    .search-submit {
      position: absolute;
      right: 28px;
      width: 36px;
      height: 36px;
      align-self: center;
      border: none;
      outline: none;
      background-color: transparent !important;
      cursor: pointer;

      img {
        width: 20px;
      }
    }
  }

  .template-container {
    display: grid;
    padding: 0 16px;
    grid-template-columns: 1fr 1fr;
    grid-gap: 16px;

    @media (max-width: 560px) {
      grid-template-columns: 1fr;
    }
  }
}

.layer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
